import api, { authHeader } from "./config";

class userApi {
    static login = (auth) => api.post("/o/token/", auth);

    static addUser = (user) => api.post("/registration", user);

    static recoverPassword = (auth) => api.post("/registration/recovery/password/", auth);

    static changePassword = (auth) => api.post("/account/password/change", 
        auth,
        { headers: authHeader()});

    static getUser = () => api.get("/user/me", { headers: authHeader()});
}

export default userApi;